/** @module Specification/SRSuppliersRenderer */
define([
	"dojo/_base/declare",
	"csi/heading/RefContainer",
], function(declare, RefContainer) {

	return declare(RefContainer, {
		/**
		 * @override
		 * Add postAction to refresh all views on the page, so that suppliers table and data package in products table are refreshed
		 */
		_getRenderAction(ctx, h) {
			const ad = this.inherited(arguments);
			if (ad) {
				ad.action.m_postAction = "postActionRefreshParentView";
			}

			return ad;
		}
	});
});
